import { SESSIONS_TEST_IDS } from '@/components/admin/sessions/contracts';
import { EXPECTED_WORD } from '@/lib/expected-noyau-words';

/**
 * The pill « attendu » of the row of the expected noyau among the six notes (npc.md §26.3, issue
 * #216, lot K): outlined in dashes in the deep bleu nuit, beside « principal », « second » and
 * « éliminé ». The word is IN the pill - the pale ground of the row is never what says it.
 */
export function ExpectedNotePill() {
  return (
    <span
      data-testid={SESSIONS_TEST_IDS.walkNoyauScoreExpected}
      className="inline-flex items-center whitespace-nowrap rounded-full border-2 border-bleu-nuit-deep border-dashed bg-white px-2 font-bold text-bleu-nuit-deep text-caption"
    >
      {EXPECTED_WORD}
    </span>
  );
}
